/* unplugin-vue-components disabled */import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "headPicture"
};
const _hoisted_2 = {
  class: "headPicture-item1"
};
const _hoisted_3 = {
  class: "headPicture-content"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "headPicture-item2"
};
const _hoisted_6 = ["src"];
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import useUserStore from "@/store/modules/user";
import variables from "@/assets/styles/variables.module.scss";
import useAppStore from "@/store/modules/app";
import useSettingsStore from "@/store/modules/settings";
import usePermissionStore from "@/store/modules/permission";
import { ElMessageBox } from "element-plus";
export default {
  __name: 'index',
  emits: ["setLayout"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const appStore = useAppStore();
    const userStore = useUserStore();
    const settingsStore = useSettingsStore();
    const permissionStore = usePermissionStore();
    const sidebarRouters = computed(() => permissionStore.sidebarRouters);
    const showLogo = computed(() => settingsStore.sidebarLogo);
    const sideTheme = computed(() => settingsStore.sideTheme);
    const theme = computed(() => settingsStore.theme);
    const isCollapse = computed(() => !appStore.sidebar.opened);
    const activeMenu = computed(() => {
      const {
        meta,
        path
      } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    });
    const emits = __emit;
    function setLayout() {
      emits("setLayout");
    }
    function logout() {
      ElMessageBox.confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        userStore.logOut().then(() => {
          // 清空userinfo
          localStorage.removeItem("userInfo");
          location.href = location.origin + location.pathname;
        });
      }).catch(() => {});
    }
    function handleCommand(command) {
      switch (command) {
        case "setLayout":
          setLayout();
          break;
        case "logout":
          logout();
          break;
        default:
          break;
      }
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([{
          'has-logo': _unref(showLogo)
        }, "topBanner"]),
        style: {
          "background": "linear-gradient(90deg, #387dd7, #54a0e1)"
        }
      }, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "logo flex_center"
      }, [_createElementVNode("span", null, " 湖口县校本作业资源平台 ")], -1)), _cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "middle"
      }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: require('@/assets/images/shouye/wode.png'),
        alt: ""
      }, null, 8, _hoisted_4), _createTextVNode(" " + _toDisplayString(_unref(userStore).userInfo.userRealName), 1)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
        class: "headPicture-content",
        onClick: logout
      }, [_createElementVNode("img", {
        src: require('@/assets/images/shouye/tuichu.png'),
        alt: ""
      }, null, 8, _hoisted_6), _cache[0] || (_cache[0] = _createTextVNode(" 退出登录 ", -1))])])])], 2);
    };
  }
};